<template>
  <div class="q-pa-md" :style="[{ height: tabHeight }, { 'overflow-y': 'auto' }]">
    <q-timeline class="moc-timeline" color="green-4">
      <q-timeline-entry
        v-for="(item, idx) in items"
        :key="idx"
        :heading="item.heading" :class="{ 'q-pb-xs': item.heading }"
        :icon="item.icon">
        <template v-if="item.title" v-slot:title>
          <b class="text-blue-14">[{{item.title}}]</b>
        </template>
        <template v-if="item.subtitle" v-slot:subtitle>
          {{item.subtitle}}
        </template>
        <q-slide-transition v-if="!item.heading">
          <div v-show="item.visible">
            <component
              :is="item.component"
              :param="param"
              @setAssessmentName="setAssessmentName"
            />
          </div>
        </q-slide-transition>
      </q-timeline-entry>
    </q-timeline>
  </div>
</template>

<script>
export default {
  name: 'third-onepage-detail',
  props: {
    param: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',
        ramStepCd: '',
      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
  data() {
    return {
      editable: true,
      visible: true,
      assessmentName: '',
      printUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      let numHeight = this.height ? Number(this.$_.replace(this.height, 'px', '')) : 600;
      if (this.editable && !this.disabled) {
        numHeight = numHeight - 70
      }
      return numHeight + 'px';
    },
    items() {
      return [
        // 평가계획
        { title: this.$comm.getLangLabel('LBL0001044'), visible: true, component: () => import(`${'./timeline/thirdPlanTL.vue'}`), param: { disabled: true, } },
        // 위험성 추정 및 결정
        { title: this.$comm.getLangLabel('LBL0001236'), visible: true, component: () => import(`${'./timeline/thirdScenarioTL.vue'}`), param: { disabled: true, } },
        // 감소대책 계획 및 실행
        { title: this.$comm.getLangLabel('LBL0001241'), visible: true, component: () => import(`${'./timeline/thirdRiskRegisterTL.vue'}`), param: { disabled: true, } },
      ]
    }
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
    },
    setAssessmentName(assessmentName) {
      this.assessmentName = assessmentName;
    },
  }
};
</script>
<style lang="sass">
.moc-timeline
  max-height: 550px
  .q-timeline__heading-title
    padding-bottom: 10px

</style>